function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { Buffer as NodeBuffer } from "buffer";
import { MESSAGE_RSOCKET_ROUTING, MESSAGE_RSOCKET_AUTHENTICATION, encodeRoute, encodeAndAddWellKnownMetadata, createBuffer, toBuffer } from "rsocket-core";
var EMPTY_BUFFER = createBuffer(0);
export function createMetadata(route, token) {
    var metadata = encodeAndAddWellKnownMetadata(EMPTY_BUFFER, MESSAGE_RSOCKET_ROUTING, encodeRoute(route));
    if (token) {
        metadata = encodeAndAddWellKnownMetadata(metadata, MESSAGE_RSOCKET_AUTHENTICATION, createBearerAuthMetadata(token));
    }
    return ensureBuffer(metadata);
}
export function createAuthMetadata(username, password) {
    var authFlag = 1; // A 플래그 설정 (1 = well-known ID 사용)
    var authTypeId = 0x00; // `simple` 인증 유형 ID (0x00)
    // A 플래그와 Auth ID 설정
    var authIdLenArray = new Uint8Array(1);
    authIdLenArray[0] = authFlag << 7 | authTypeId;
    // Username과 Password를 UTF-8로 인코딩
    var usernameArray = new TextEncoder().encode(username);
    var passwordArray = new TextEncoder().encode(password);
    // Username Length 포함한 인증 페이로드 배열 생성
    var usernameLengthArray = new Uint8Array(1);
    usernameLengthArray[0] = usernameArray.length;
    // 최종 인증 메타데이터 배열 생성
    var totalLength = authIdLenArray.length + usernameLengthArray.length + usernameArray.length + passwordArray.length;
    var authMetadataArray = new Uint8Array(totalLength);
    // 각 부분을 최종 배열에 설정
    var offset = 0;
    authMetadataArray.set(authIdLenArray, offset);
    offset += authIdLenArray.length;
    authMetadataArray.set(usernameLengthArray, offset);
    offset += usernameLengthArray.length;
    authMetadataArray.set(usernameArray, offset);
    offset += usernameArray.length;
    authMetadataArray.set(passwordArray, offset);
    return authMetadataArray;
}
export function createBearerAuthMetadata(token) {
    var authTypeId = 0x01;
    var header = createBuffer(1);
    header[0] = 0x80 | authTypeId;
    var tokenBytes = ensureBuffer(token);
    return concatBuffers(header, tokenBytes);
}
export function createSetupMetadata(token) {
    if (!token) {
        return EMPTY_BUFFER;
    }
    var result = encodeAndAddWellKnownMetadata(EMPTY_BUFFER, MESSAGE_RSOCKET_AUTHENTICATION, createBearerAuthMetadata(token));
    return ensureBuffer(result);
}
function concatBuffers(head, tail) {
    var result = createBuffer(head.length + tail.length);
    result.set(head, 0);
    result.set(tail, head.length);
    return ensureBuffer(result);
}
function ensureBuffer(value) {
    if (typeof value === "string") {
        return NodeBuffer.from(value, "utf8");
    }
    if (NodeBuffer.isBuffer(value)) {
        return value;
    }
    if (_instanceof(value, Uint8Array)) {
        return NodeBuffer.from(value);
    }
    if (isCopyableBuffer(value)) {
        var copySource = value;
        var target = NodeBuffer.alloc(copySource.length);
        copySource.copy(target, 0, 0, copySource.length);
        return target;
    }
    return NodeBuffer.from(toBuffer(value));
}
function isCopyableBuffer(value) {
    return !!value && typeof value.copy === "function" && typeof value.length === "number";
}
